module.exports = __webpack_public_path__ + "media/packs/images/flags/RU-46e6ae97902f4db4787edbd04df3a7bb.svg";